import React from 'react'
import Taxlist from './Taxlist'

const Tax = () => {
  return (
    <>
    <Taxlist />
    </>
  )
}

export default Tax